import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { closeStationery } from "./closeStationery";

export const deleteStationery = async (code: number, params: stdObject) => {
  const {
    t,
    customUpdate,
    docValues,
    closeMsg,
    setMsg3,
    setDocValues,
    setStationeryModal,
    setMsg,
    documentAction,
    openWindow,
    logoutAction,
  } = params;
  setMsg3("loading");
  const payloadDeleteStationery = { code };
  console.log("payloadDeleteStationery", payloadDeleteStationery);
  const responseDeleteStationery: stdObject = await sendData({
    endPoint: "deleteStationery",
    payload: payloadDeleteStationery,
    logoutAction,
  });
  console.log(
    "responseDeleteStationery",
    responseDeleteStationery,
    Object.keys(responseDeleteStationery)
      .map((e) => responseDeleteStationery[e])
      .join(""),
  );
  if (responseDeleteStationery.success && responseDeleteStationery.status) {
    customUpdate.current = { stationeryInfo: docValues.index };
    closeMsg(3);
    closeStationery(true, {
      docValues,
      setDocValues,
      setStationeryModal,
      setMsg,
      documentAction,
      openWindow,
      closeMsg,
    });
  } else {
    setMsg3("error");
  }
  return;
};
